import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createValueItem } from "../../api/apiValueItems";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export function useCreateValueItem() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createItemMutate, isPending } = useMutation({
        mutationFn: createValueItem,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["value-items"] });
            navigate("/values");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create value item");
        },
    });

    return { createItemMutate, isPending };
}
